import { Component, OnInit, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';
import { ngxCsv } from 'ngx-csv/ngx-csv';

import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';

interface KeyValue {
  key: string;
  value: string;
  keyValue?: KeyValue[];
}

interface NameValue {
  key: string;
  value: string;
  boxType: string;
  isMandatory: boolean;
  keyValue?: NameValue[] | string[];
}

@Component({
  selector: 'app-object-template',
  templateUrl: './object-template.component.html',
  styleUrls: ['./object-template.component.css']
})
export class ObjectTemplateComponent implements OnInit {
  @ViewChild('paginator') paginator: any;

  objectForm: any | FormGroup;
  editTemplateForm: any | FormGroup;
  allTemplates: any = []
  objectTemplateList: any = []
  singleTemplate: any = []
  objectTemplateId = ""
  page: number = 1;
  pageNo: number = 0
  count: number = 0;
  tableSize: number = 10;
  recordsPerPage: number = 10
  first: number = 0;
  tableSizes: any = [3, 6, 9, 12];
  cid: any
  groupTypeList: any = []
  paramTypes = [
    "USERPARAMS",
    "CUSTREG"
  ]

  isAllChecked: any = false
  branch: any = false
  department: any = false
  location: any = false
  serialNumber: any = false
  originalCost: any = false
  currentCost: any = false
  warranty: any = false
  purchase: any = false
  parentAssetIdFlag: any = false
  depreciationRequired: any = false
  make: any = false
  model: any = false
  quantity: any = false
  uom: any = false;
  uomName: any = "";
  uomData: any = [];
  deploy: any = false
  defaultNameValue: any = []

  isLoading: any = false

  objectGroupData: any = []
  objectTypeData: any = []
  formSubmit: boolean = false;
  recordName: any = ""
  recordId: any = ""

  searchFilter: any = ""
  iconUrlEdit: any = ""

  warrantyInfo: any = [
    { "key": "Warranty Id", "value": "" },
    { "key": "Warranty Type (limited warranty, extended warranty, full warranty)", "value": "" },
    { "key": "Warranty Period", "value": "" },
    { "key": "Warranty Period In (Years / Months / Days)", "value": "" },
    { "key": "Coverage Start Date", "value": "" },
    { "key": "Coverage End Date", "value": "" },
    { "key": "Coverage Parts (parts, labor, defects, repairs etc)", "value": "" },
    { "key": "Exclusions - NOT covered under the warranty (e.g., wear and tear, accidental damage, misuse)", "value": "" },
    { "key": "Proof of Purchase (Scan and Upload Bill or invoice etc)", "value": "" },
    { "key": "Warranty Provider (Manufacturer, Authorised Service Center)", "value": "" },
    { "key": "Repair Replacement Policy (Details on whether the warranty covers repair, replacement, or a refund)", "value": "" }
  ];

  purchaseInfo: any = [
    { "key": "Invoice Id", "value": "" },
    { "key": "Invoice Date", "value": "" },
    { "key": "Vendor Id", "value": "" },
    { "key": "Vendor Name", "value": "" },
  ]


  constructor(private fb: FormBuilder, private toastr: ToastrService, private generic_service: GenericService) { }

  ngOnInit(): void {
    this.cid = Number(sessionStorage.getItem('cid'))
    this.generateMockRecords(28)
    this.getAllObjectTemplate()
    this.getAllObjectTemplateWithPagination(this.pageNo, this.recordsPerPage)
    this.getAllGroupList()
    this.getAllTypeList()
    this.getAllUomMaster()
    this.objectForm = this.fb.group({
      description: [''],
      name: ['', [Validators.required]],
      type: ['', [Validators.required]],
      group: ['', [Validators.required]],
      iconUrl: ['', [Validators.required]],
      nameValue: this.fb.array([])
    })


    this.editTemplateForm = this.fb.group({
      description: [''],
      name: ['', [Validators.required]],
      type: ['', [Validators.required]],
      group: ['', [Validators.required]],
      iconUrl: [''],
      nameValue: this.fb.array([])
    });
  }

  getAllTypeList() {
    this.generic_service.getAllTypeList().subscribe(
      (res: any) => {
        console.log(res)
        this.objectTypeData = res.response
      },
      (err: any) => {
        console.log(err)
      }
    )
  }

  getAllUomMaster() {
    this.generic_service.getAllUomMaster().subscribe(
      (res: any) => {
        this.uomData = res.response
      }
    )
  }

  getAllGroupList() {
    this.generic_service.getAllGroupList().subscribe(
      (res: any) => {
        console.log(res)
        this.objectGroupData = res.response
      },
      (err: any) => {
        console.log(err)
      }
    )
  }

  onTableDataChange(event: any) {

    console.log(event)
    this.pageNo = event.page;
    this.first = event.first;
    this.recordsPerPage = event.rows;


    if (this.searchFilter != "") {
      this.getObjectTemplateByWildSearchWithPagination(this.pageNo, this.recordsPerPage)
    } else {
      this.getAllObjectTemplateWithPagination(this.pageNo, this.recordsPerPage);
    }
  }

  get objectArr() {
    return this.objectForm.get('nameValue') as FormArray;
  }

  nameValue() {
    return this.fb.group({
      "key": ['']
    })
  }

  addNameValue() {
    this.keys.push({
      "key": "",
      "value": "",
      "keyValue": []
    })
  }

  removeNameValue(index: number) {
    this.keys.splice(index, 1)
  }

  addPerformanceMatrix() {
    this.performanceMatrix.push({
      "key": "",
      "value": "",
      "keyValue": []
    })
  }

  removePerformanceMatrix(index: number) {
    this.performanceMatrix.splice(index, 1)
  }

  addSubPerformanceMatrix(i: any) {
    this.performanceMatrix[i].keyValue.push(
      {
        "key": "",
        "value": "",
        "keyValue": []
      }
    )
  }


  removeSubPerformanceMatrix(i: any, j: any) {
    this.performanceMatrix[i].keyValue.splice(j, 1)
  }

  addSubPerformanceMatrix2(i: any, j: any) {
    this.performanceMatrix[i].keyValue[j].keyValue.push(
      {
        "key": "",
        "value": "",
        "keyValue": []
      }
    )
  }

  removeSubPerformanceMatrix2(i: any, j: any, k: any) {
    this.performanceMatrix[i].keyValue[j].keyValue.splice(k, 1)
  }

  addSubPerformanceMatrix3(i: any, j: any, k: any) {
    this.performanceMatrix[i].keyValue[j].keyValue[k].keyValue.push(
      {
        "key": "",
        "value": ""
      }
    )
  }

  removeSubPerformanceMatrix3(i: any, j: any, k: any, l: any) {
    this.performanceMatrix[i].keyValue[j].keyValue[k].keyValue.splice(l, 1)
  }

  performanceMatrix: any = [
    {
      "key": "",
      "value": "",
      "keyValue": []
    }
  ]

  keys: any = [
    {
      "key": "",
      "value": "",
      "keyValue": []
    }
  ]

  addSubkey(i: any) {
    this.keys[i].keyValue.push(
      {
        "key": "",
        "value": "",
        "keyValue": []
      }
    )
  }

  removeSubkey(i: any, j: any) {
    this.keys[i].keyValue.splice(j, 1)
  }

  addSubkey2(i: any, j: any) {
    this.keys[i].keyValue[j].keyValue.push(
      {
        "key": "",
        "value": "",
        "keyValue": []
      }
    )
  }

  removeSubkey2(i: any, j: any, k: any) {
    this.keys[i].keyValue[j].keyValue.splice(k, 1)
  }

  addSubkey3(i: any, j: any, k: any) {
    this.keys[i].keyValue[j].keyValue[k].keyValue.push(
      {
        "key": "",
        "value": ""
      }
    )
  }

  removeSubkey3(i: any, j: any, k: any, l: any) {
    this.keys[i].keyValue[j].keyValue[k].keyValue.splice(l, 1)
  }

  closeModal() {
    this.keys = [
      {
        "key": "",
        "value": "",
        "keyValue": []
      }
    ]

    this.performanceMatrix = [
      {
        "key": "",
        "value": "",
        "keyValue": []
      }
    ]
    this.clearData()
  }

  clearData() {
    this.objectForm.reset()
    this.editTemplateForm.reset()
    this.performanceMatrix = []
    this.addPerformanceMatrix()
    this.branch = false
    this.department = false
    this.location = false
    this.serialNumber = false
    this.originalCost = false
    this.currentCost = false
    this.warranty = false
    this.purchase = false
    this.parentAssetIdFlag = false
    this.depreciationRequired = false
    this.make = false
    this.model = false
    this.quantity = false
    this.uom = false
    this.uomName = ""
    this.deploy = false

    const fileInput = document.getElementById("iconUrl") as HTMLInputElement;
    if (fileInput) {
      fileInput.value = '';
    }
  }

  removeFile(fileInput: HTMLInputElement) {
    fileInput.value = '';
    this.objectForm.patchValue({
      iconUrl: ""
    })
  }

  addObjectTemplate() {

    if (this.formSubmit) {
      return
    }

    this.formSubmit = true;

    if (!this.objectForm.valid) {
      this.formSubmit = false;
      this.toastr.error("Please fill in all required fields");
      return
    }

    let nameValue: any = this.convertToNameValue(this.keys);
    let performanceMatrix: any = this.convertToNameValue(this.performanceMatrix);

    let body = {
      "version": 0,
      "isActive": true,
      "description": "",
      "branch": this.branch,
      "department": this.department,
      "make": this.make,
      "model": this.model,
      "location": this.location,
      "serialNumber": this.serialNumber,
      "originalCost": this.originalCost,
      "currentCost": this.currentCost,
      "warranty": this.warranty,
      "warrantyInfo": this.warranty ? this.warrantyInfo : [],
      "purchase": this.purchase,
      "quantity": this.quantity,
      "uOM": this.quantity,
      "uomName": this.uomName,
      "deploy": this.deploy,
      "iconUrl": this.objectForm.get('iconUrl').value,
      "parentAssetIdFlag": this.parentAssetIdFlag,
      "purchaseInfo": this.purchase ? this.purchaseInfo : [],
      "depreciationRequired": this.depreciationRequired,
      "name": String(this.objectForm.get('name').value),
      "type": String(this.objectForm.get('type').value),
      "group": String(this.objectForm.get('group').value),
      "performanceMatrix": performanceMatrix,
      "nameValue": nameValue,
      "cid": Number(this.cid)
    }
    console.log(body)
    this.generic_service.addObjectTemplate(body).subscribe(
      (response: any) => {
        console.log(response)
        this.objectForm.reset()
        this.getAllObjectTemplateWithPagination(this.pageNo, this.recordsPerPage)
        this.toastr.success(response.message)
        this.cancelModel()
        this.performanceMatrix = []
        this.addPerformanceMatrix()
        this.formSubmit = false;
        this.clearData()

      },
      (error: any) => {
        this.formSubmit = false;
        this.toastr.error(error.error.errors[0].description);
        console.log(error)
      }
    )
  }


  getAllObjectTemplateWithPagination(pageNo: any, recordsPerPage: any) {
    this.isLoading = true
    this.generic_service.getAllObjectTemplateWithPagination(pageNo, recordsPerPage).subscribe(
      (response: any) => {
        console.log(response)
        this.objectTemplateList = []
        this.objectTemplateList = response.response.objectTemplateList
        this.count = response.response.totalRecords
        this.isLoading = false

      },
      (error: any) => {
        console.log(error)
      }
    )
  }

  getAllObjectTemplate() {
    this.isLoading = true

    this.generic_service.getAllObjectTemplate().subscribe(
      (response: any) => {
        console.log(response)
        this.allTemplates = response.response
        this.count = response.response.length
        this.isLoading = false

      },
      (error: any) => {
        console.log(error)
      }
    )
  }

  cancelModel() {
    document.getElementById("closeModalButton2")?.click()
    document.getElementById("closeModalButton1")?.click()
    document.getElementById("closeModalButton3")?.click()
    document.getElementById("closeModalButtonEdit")?.click()
    this.recordName = ""
    this.recordId = ""
  }

  cloneTemplate(id: any) {
    this.generic_service.getObjectTemplateById(id).subscribe(
      (response: any) => {
        console.log("Cloning template: ", response)
        this.branch = response.response.branch || false
        this.department = response.response.department || false
        this.originalCost = response.response.originalCost || false
        this.currentCost = response.response.currentCost || false
        this.make = response.response.make || false
        this.model = response.response.model || false
        this.location = response.response.location || false
        this.serialNumber = response.response.serialNumber || false
        this.quantity = response.response.quantity || false
        this.uom = response.response.uom || false
        this.uomName = response.response.uomName || ""
        this.deploy = response.response.deploy || false
        this.parentAssetIdFlag = response.response.parentAssetIdFlag || false
        this.warranty = response.response.warranty || false
        this.purchase = response.response.purchase || false
        this.depreciationRequired = response.response.depreciationRequired || false

        this.objectForm.patchValue({
          name: response.response.name + " (Copy)",
          type: response.response.type,
          group: response.response.group,
          iconUrl: response.response.iconUrl || ""
        })

        if (response.response.performanceMatrix && response.response.performanceMatrix != null && response.response.performanceMatrix.length != 0) {
          this.performanceMatrix = JSON.parse(JSON.stringify(response.response.performanceMatrix))
        } else {
          this.performanceMatrix = [{ "key": "", "value": "", "keyValue": [] }]
        }

        if (response.response.nameValue && response.response.nameValue != null && response.response.nameValue.length != 0) {
          this.keys = JSON.parse(JSON.stringify(response.response.nameValue))
        } else {
          this.keys = [{ "key": "", "value": "", "keyValue": [] }]
        }
      },
      (error: any) => {
        console.log(error)
      }
    )
  }

  getObjectTemplateById(id: any) {
    this.generic_service.getObjectTemplateById(id).subscribe(
      (response: any) => {
        console.log(response)
        this.singleTemplate = []
        this.singleTemplate.push(response.response);
        this.branch = response.response.branch
        this.department = response.response.department
        this.originalCost = response.response.originalCost
        this.currentCost = response.response.currentCost
        this.make = response.response.make
        this.model = response.response.model
        this.location = response.response.location
        this.serialNumber = response.response.serialNumber
        this.quantity = response.response.quantity
        this.uom = response.response.uom
        this.uomName = response.response.uomName

        this.editTemplateForm.patchValue({
          name: response.response.name,
          type: response.response.type,
          group: response.response.group
        })

        if (response.response.performanceMatrix && response.response.performanceMatrix != null && response.response.performanceMatrix != undefined && response.response.performanceMatrix.length != 0) {
          this.performanceMatrix = response.response.performanceMatrix
        } else {
          this.performanceMatrix = [
            {
              "key": "",
              "value": "",
              "keyValue": []
            }
          ]
        }

        if (response.response.nameValue && response.response.nameValue != null && response.response.nameValue != undefined && response.response.nameValue.length != 0) {
          this.keys = response.response.nameValue
        } else {
          this.keys = [
            {
              "key": "",
              "value": "",
              "keyValue": []
            }
          ]
        }
      },
      (error: any) => {
        console.log(error)
      }
    )
  }

  selectDelete(id: any, record: any) {
    this.objectTemplateId = id;
    this.recordId = record.objectTemplateId;
    this.recordName = record.name;
  }

  loadData() {
    if (this.searchFilter != "") {
      this.getObjectTemplateByWildSearchWithPagination(this.pageNo, this.recordsPerPage)
    } else {
      this.getAllObjectTemplate()
    }
  }

  deleteObjectTemplate() {
    this.generic_service.deleteObjectTemplate(this.objectTemplateId).subscribe(
      (response: any) => {
        console.log(response);
        this.cancelModel()
        this.toastr.success(response.message)
        this.loadData()
      },
      (error: any) => {
        console.log(error)
        this.toastr.error(error.error.errors[0].description);

      }
    )
  }




  //   convertToNameValue(input: KeyValue[]): NameValue[] {
  //     return input.map(item => this.mapItem(item));
  //   }

  // mapItem(item: KeyValue): NameValue {
  //   const mapped: NameValue = {
  //     key: item.key,
  //     value: item.value || '',
  //     boxType: 'string',
  //     isMandatory: true,
  //     keyValue: []
  //   };

  //   if (item.keyValue && item.keyValue.length > 0) {
  //     mapped.keyValue = item.keyValue.map(child => this.mapItem(child));
  //   } else {
  //     mapped.keyValue = [item.key];
  //   }

  //   return mapped;
  // }


  private convertToNameValue(input: KeyValue[]): NameValue[] {
    return input
      .filter(item => item.key && item.key.trim() !== '')
      .map(item => this.mapItem(item))
      .filter(this.isNameValue); // Use type guard here
  }

  private mapItem(item: KeyValue): NameValue | null {
    if (!item.key || item.key.trim() === '') {
      return null; // Skip if key is empty
    }

    const mapped: NameValue = {
      key: item.key,
      value: item.value || '',
      boxType: 'string',
      isMandatory: true,
      keyValue: []
    };

    if (item.keyValue && item.keyValue.length > 0) {
      const children = item.keyValue
        .filter(child => child.key && child.key.trim() !== '')
        .map(child => this.mapItem(child))
        .filter(this.isNameValue); // Use type guard again

      mapped.keyValue = children.length > 0 ? children : [];
    } else {
      mapped.keyValue = [];
    }

    return mapped;
  }

  // 👇 Type guard to ensure we only keep valid NameValue items
  private isNameValue(item: NameValue | null): item is NameValue {
    return item !== null;
  }

  updateObjectTemplate() {

    if (this.formSubmit) {
      return
    }

    this.formSubmit = true;

    if (!this.editTemplateForm.valid) {
      this.formSubmit = false;
      this.toastr.error("Please fill in all required fields");
      return
    }

    let nameValue: any = this.convertToNameValue(this.keys);
    let performanceMatrix: any = this.convertToNameValue(this.performanceMatrix);

    let body = {
      "version": 0,
      "isActive": true,
      "description": "",
      "branch": this.branch,
      "department": this.department,
      "make": this.make,
      "model": this.model,
      "location": this.location,
      "serialNumber": this.serialNumber,
      "name": String(this.editTemplateForm.get('name').value),
      "type": String(this.editTemplateForm.get('type').value),
      "group": String(this.editTemplateForm.get('group').value),
      "performanceMatrix": performanceMatrix,
      "nameValue": nameValue,
      "cid": Number(this.cid),
      "id": this.singleTemplate[0].id,
      "objectTemplateId": this.singleTemplate[0].objectTemplateId,
      "quantity": this.quantity,
      "uom": this.quantity,
      "uomName": this.uomName
    }
    console.log(body)
    this.generic_service.updateObjectTemplate(body).subscribe(
      (response: any) => {
        console.log(response)
        this.objectForm.reset()
        this.editTemplateForm.reset()
        this.getAllObjectTemplate()
        this.toastr.success(response.message)
        this.cancelModel()
        this.performanceMatrix = []
        this.addPerformanceMatrix()
        this.clearData()
      },
      (error: any) => {
        console.log(error)
      }
    )
  }

  refreshAll() {
    this.pageNo = 0
    this.first = 0
    this.searchFilter = ""
    setTimeout(() => {
      if (this.paginator) {
        this.paginator.changePage(0);
      }
    }, 0);
    this.getAllObjectTemplateWithPagination(this.pageNo, this.recordsPerPage)
  }

  search() {
    if (this.searchFilter == "" || this.searchFilter == null) {
      this.refreshAll();
      return;
    }
    this.pageNo = 0;
    this.first = 0;
    setTimeout(() => {
      if (this.paginator) {
        this.paginator.changePage(0);
      }
    }, 0);
    this.getObjectTemplateByWildSearchWithPagination(this.pageNo, this.recordsPerPage);
  }


  getObjectTemplateByWildSearchWithPagination(pageNo: number, recordsPerPage: number) {
    console.log(this.searchFilter)
    if (this.searchFilter == "" || this.searchFilter == null) {
      return
    }
    this.generic_service.getObjectTemplateByWildSearchWithPagination(this.searchFilter, pageNo, recordsPerPage).subscribe(
      (res: any) => {
        if (res.response == null || res.response.length == 0 || res.response == undefined) {
          this.allTemplates = []
          this.count = 0
          return

        }
        this.objectTemplateList = res.response.objectTemplateList
        this.count = res.response.totalRecords
      },
      (err: any) => {
        console.log('Serial Number Error:', err);
      }
    );
  }





  downLoadExcel() {
    let excelData: any = []

    const test: any = {
      "description": "",
      "name": "",
      "type": "",
      "group": "",
      "objectCondition": "",
      "givenName": "",
      "acquisitionDate": "",
      "assetLifeNumber": 0,
      "lat": 0,
      "lng": 0,
      "asset_Category": "",
      "serialNumberCheckBox": this.singleTemplate[0].serialNumber || false,
      "branchCheckBox": this.singleTemplate[0].branch || false,
      "departmentCheckBox": this.singleTemplate[0].department || false,
      "locationCheckBox": this.singleTemplate[0].location || false,
      "makeCheckBox": this.singleTemplate[0].make || false,
      "modelCheckBox": this.singleTemplate[0].model || false,
      "originalCostCheckBox": this.singleTemplate[0].originalCost || false,
      "currentCostCheckBox": this.singleTemplate[0].currentCost || false,
      "depreciationCheckbox": this.singleTemplate[0].depreciationRequired || false,
    };
    // Mapping checkboxes to their actual data keys
    const checkboxFieldMap: any = {
      serialNumberCheckBox: ['serialNumber'],
      branchCheckBox: ['branch'],
      departmentCheckBox: ['department'],
      locationCheckBox: ['location'],
      makeCheckBox: ['make'],
      modelCheckBox: ['model'],
      originalCostCheckBox: ['originalCost'],
      currentCostCheckBox: ['currentCost'],
      depreciationCheckbox: ['salvageValue', 'depreciationMethod'],
    };

    const filteredObject: any = {};

    for (const key in test) {
      if (test[key] === "") {
        filteredObject[key] = "";
      } else if (test[key] === true && checkboxFieldMap[key]) {
        checkboxFieldMap[key].forEach((field: string) => {
          filteredObject[field] = "";
        });
      }
    }

    const result = filteredObject;

    excelData.push(result)
    console.log(result)
    let keys = Object.keys(result)
    console.log(keys)
    var options = {
      fieldSeparator: ',',
      quoteStrings: '"',
      decimalseparator: '.',
      showLabels: false,
      showTitle: false,
      useBom: false,
      headers: keys
    };

    new ngxCsv(excelData, 'Report', options);
  }


  convertTestToDataArray() {
    const test: any = {
      "description": "",
      "name": "",
      "type": "",
      "group": "",
      "objectCondition": "",
      "givenName": "",
      "acquisitionDate": "",
      "assetLifeNumber": 0,
      "lat": 0,
      "lng": 0,
      "asset_Category": "",
      "serialNumberCheckBox": this.singleTemplate[0].serialNumber || false,
      "branchCheckBox": this.singleTemplate[0].branch || false,
      "departmentCheckBox": this.singleTemplate[0].department || false,
      "locationCheckBox": this.singleTemplate[0].location || false,
      "makeCheckBox": this.singleTemplate[0].make || false,
      "modelCheckBox": this.singleTemplate[0].model || false,
      "originalCostCheckBox": this.singleTemplate[0].originalCost || false,
      "currentCostCheckBox": this.singleTemplate[0].currentCost || false,
      "depreciationCheckbox": this.singleTemplate[0].depreciationRequired || false,
    };


    // Mapping checkboxes to their actual data keys
    const checkboxFieldMap: any = {
      serialNumberCheckBox: ['serialNumber'],
      branchCheckBox: ['branch'],
      departmentCheckBox: ['department'],
      locationCheckBox: ['location'],
      makeCheckBox: ['make'],
      modelCheckBox: ['model'],
      originalCostCheckBox: ['originalCost'],
      currentCostCheckBox: ['currentCost'],
      depreciationCheckbox: ['salvageValue', 'depreciationMethod'],
    };

    const filteredObject: any = {};

    for (const key in test) {
      if (test[key] === "") {
        filteredObject[key] = "";
      } else if (test[key] === true && checkboxFieldMap[key]) {
        checkboxFieldMap[key].forEach((field: string) => {
          filteredObject[field] = "";
        });
      }
    }

    const result = filteredObject;

  }



  isExcelDownload: any = false

  downloadExcel() {
    if (this.isExcelDownload) return;

    this.isExcelDownload = true;

    const data: any[] = [];

    // Friendly label mapping
    const labelMap: any = {
      acquisitionDate: 'Acquisition Date',
      assetLifeNumber: 'Asset Life Number',
      lat: 'Lat',
      lng: 'Lng',
      givenName: "Name",
      objectCondition: "Condition",
      asset_Category: 'Category',
      serialNumberCheckBox: 'Serial Number',
      branchCheckBox: 'Branch',
      departmentCheckBox: 'Department',
      locationCheckBox: 'Location',
      makeCheckBox: 'Make',
      modelCheckBox: 'Model',
      originalCostCheckBox: 'Original Cost',
      currentCostCheckBox: 'Current Cost',
      depreciationCheckbox: ['Salvage Value', 'Depreciation Method']
    };

    // The checkbox field mapping
    const checkboxFieldMap: any = {
      serialNumberCheckBox: this.singleTemplate[0].serialNumber || false,
      branchCheckBox: this.singleTemplate[0].branch || false,
      departmentCheckBox: this.singleTemplate[0].department || false,
      locationCheckBox: this.singleTemplate[0].location || false,
      makeCheckBox: this.singleTemplate[0].make || false,
      modelCheckBox: this.singleTemplate[0].model || false,
      originalCostCheckBox: this.singleTemplate[0].originalCost || false,
      currentCostCheckBox: this.singleTemplate[0].currentCost || false,
      depreciationCheckbox: this.singleTemplate[0].depreciationRequired || false
    };

    // Static fields always shown
    const baseFields: any = {
      givenName: '',
      objectCondition: '',
      acquisitionDate: '',
      assetLifeNumber: 0,
      lat: 0,
      lng: 0,
      asset_Category: '',
    };

    // Prepare the export row
    const row: any = {};

    // Add static fields with labels
    for (const key in baseFields) {
      const label = labelMap[key];
      if (label) {
        row[label] = baseFields[key];
      }
    }

    // Add selected checkbox fields
    for (const key in checkboxFieldMap) {
      if (checkboxFieldMap[key] === true) {
        const labels = labelMap[key];
        if (Array.isArray(labels)) {
          labels.forEach(label => row[label] = '');
        } else {
          row[labels] = '';
        }
      }
    }

    // Push row to data array
    data.push(row);

    // Convert to worksheet and workbook
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(data);
    const workbook: XLSX.WorkBook = {
      Sheets: { 'Report': worksheet },
      SheetNames: ['Report']
    };

    // Generate Excel file
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const blobData: Blob = new Blob([excelBuffer], { type: 'application/octet-stream' });

    const name = `${this.singleTemplate[0].name}_template_${this.singleTemplate[0].objectTemplateId}_.xlsx`;
    FileSaver.saveAs(blobData, name);

    this.isExcelDownload = false;
  }


  bulkData: any = []

  onExcelFileChange(event: any, excelFileInput: HTMLInputElement): void {
    const target: DataTransfer = <DataTransfer>(event.target);

    if (target.files.length !== 1) {
      console.error('Please upload a single file.');
      return;
    }

    const file = target.files[0];
    console.log(file.name)


    // Use regex to extract numbers from the filename
    // const fileName = file.name.match(/\d+/); 
    let fileName = file.name.match(/_(\d+)_/); // match number surrounded by underscores
    let templateId: any = ""

    if (fileName) {
      let fileId: any = fileName[0].match(/\d+/)

      const number = parseInt(fileId[0], 10);
      templateId = number
      console.log(fileName);
      console.log('Extracted number:', number);

    } else {
      console.log('No number found in file name.');
      excelFileInput.value = '';

      return
    }

    const reader: FileReader = new FileReader();

    reader.onload = (e: any) => {
      const binaryStr: string = e.target.result;
      const workbook: XLSX.WorkBook = XLSX.read(binaryStr, { type: 'binary' });

      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];
      let data: any = XLSX.utils.sheet_to_json(worksheet, { defval: '' });

      console.log('Parsed Excel Data:', data);

      this.generic_service.getObjectTemplateById(templateId).subscribe(
        (res: any) => {
          for (let list of data) {
            list.branchCheckBox = res.response.branch || false
            list.departmentCheckBox = res.response.department || false
            list.locationCheckBox = res.response.location || false
            list.makeCheckBox = res.response.make || false
            list.modelCheckBox = res.response.model || false
            list.originalCostCheckBox = res.response.originalCost || false
            list.currentCostCheckBox = res.response.currentCost || false
            list.serialNumberCheckBox = res.response.serialNumber || false
            list.depreciationCheckbox = res.response.depreciationRequired || false
          }

          this.bulkData = data
          console.log(this.bulkData)

        }
      )



      console.log(this.bulkData)
    };

    reader.readAsBinaryString(file);
  }



  generateMockRecords(count: number) {
    const records = [];

    for (let i = 1; i <= count; i++) {
      records.push({
        description: `Asset description ${i}`,
        name: `Asset ${i}`,
        type: `Type ${i % 3 + 1}`,
        group: `Group ${i % 5 + 1}`,
        objectCondition: ['New', 'Used', 'Refurbished'][i % 3],
        givenName: `Given Name ${i}`,
        acquisitionDate: `2023-0${(i % 9) + 1}-15`,
        assetLifeNumber: `${5 + i % 10} years`,
        lat: (25 + Math.random()).toFixed(6),
        lng: (55 + Math.random()).toFixed(6),
        asset_Category: `Category ${i % 4 + 1}`,
        serialNumber: `SN${1000 + i}`,
        branch: `Branch ${i % 3 + 1}`,
        department: `Dept ${i % 4 + 1}`,
        location: `Location ${i}`,
        make: `Make ${i % 3 + 1}`,
        model: `Model ${i}`,
        originalCost: `${1000 + i * 100}`,
        currentCost: `${800 + i * 80}`,

        // booleans unchanged
        branchCheckBox: true,
        departmentCheckBox: true,
        locationCheckBox: true,
        makeCheckBox: true,
        modelCheckBox: true,
        originalCostCheckBox: true,
        currentCostCheckBox: true,
        serialNumberCheckBox: true,
        depreciationCheckbox: false
      });
    }

    console.log(records)

    // return records;
  }



  addImageButton(imageButton: any) {
    document.getElementById(imageButton)?.click()
  }

  onImageChange(event: any, image: any, isAddOrEdit: any) {
    const file = event.target.files[0];
    const validTypes = ['image/png', 'image/jpeg', 'image/jpg'];
    if (!validTypes.includes(file.type)) {
      this.toastr.error('Only .png, .jpg, and .jpeg files are allowed.')
      const fileInput = document.getElementById(image) as HTMLInputElement;
      if (fileInput) {
        fileInput.value = '';
      }
      return;
    }
    this.uploadImage(file, image, isAddOrEdit)
  }

  uploadImage(file: any, image: any, isAddOrEdit: any) {
    this.generic_service.uploadImage(file).subscribe((response: any) => {
      console.log(response);


      if (isAddOrEdit == 'add') {
        if (image == "iconUrl") {
          this.objectForm.patchValue({
            iconUrl: response.response
          })
        }

      } else {
        if (image == "iconUrl") {
          this.editTemplateForm.patchValue({
            iconUrl: response.response
          })
        }
      }
    });
  }

  removeIcon(image: any, isAddOrEdit: any) {
    const fileInput = document.getElementById(image) as HTMLInputElement;
    if (fileInput) {
      fileInput.value = '';
    }
    if (isAddOrEdit == "add") {
      if (image == "iconUrl") {
        this.objectForm.patchValue({
          iconUrl: ""
        })
      }
    } else {
      if (image == "iconUrl") {
        this.objectForm.patchValue({
          iconUrl: ""
        })
      }
    }
  }



  onImageChangeEdit(event: any) {
    const file = event.target.files[0];
    const validTypes = ['image/png', 'image/jpeg', 'image/jpg'];
    if (!validTypes.includes(file.type)) {
      this.toastr.error('Only .png, .jpg, and .jpeg files are allowed.')
      return;
    }
    this.uploadImageEdit(file)
  }

  uploadImageEdit(file: any) {
    this.generic_service.uploadImage(file).subscribe((response: any) => {
      console.log(response);
      this.iconUrlEdit = response.response

      let body: any = {
        "objectTemplateId": this.singleTemplate[0].objectTemplateId,
        "icon": response.response,
        "cid": this.cid
      }

      this.generic_service.updateObjectTemplateIcon(body).subscribe(
        (response: any) => {
          this.getObjectTemplateById(this.singleTemplate[0].objectTemplateId)
        }
      )
    });
  }

  removeIconEdit() {
    let body: any = {
      "objectTemplateId": this.singleTemplate[0].objectTemplateId,
      "icon": "",
      "cid": this.cid
    }

    this.generic_service.updateObjectTemplateIcon(body).subscribe(
      (response: any) => {
        this.getObjectTemplateById(this.singleTemplate[0].objectTemplateId)
      }
    )
  }



  allCheck1(event: any) {
    console.log(event.target.checked)
    if (event.target.checked) {
      this.branch = true
      this.department = true
      this.location = true
      this.serialNumber = true
      this.originalCost = true
      this.currentCost = true
      this.warranty = true
      this.purchase = true
      this.parentAssetIdFlag = true
      this.depreciationRequired = true
      this.make = true
      this.model = true
      this.quantity = true
      this.deploy = true
    } else {
      this.branch = false
      this.department = false
      this.location = false
      this.serialNumber = false
      this.originalCost = false
      this.currentCost = false
      this.warranty = false
      this.purchase = false
      this.parentAssetIdFlag = false
      this.depreciationRequired = false
      this.make = false
      this.model = false
      this.quantity = false
      this.deploy = false
    }

  }

  allCheck(event: any) {
    const isChecked = event.target.checked;
    console.log(isChecked);

    const fields: (keyof this)[] = [
      'branch',
      'department',
      'location',
      'serialNumber',
      'originalCost',
      'currentCost',
      'warranty',
      'purchase',
      'parentAssetIdFlag',
      'depreciationRequired',
      'make',
      'model',
      'quantity',
      'deploy'
    ];

    fields.forEach(field => {
      this[field] = isChecked;
    });
  }

  allFlags: (keyof ObjectTemplateComponent)[] = [
    'branch', 'department', 'location', 'serialNumber', 'originalCost',
    'currentCost', 'warranty', 'purchase', 'parentAssetIdFlag', 'depreciationRequired',
    'make', 'model', 'quantity', 'deploy'
  ];


  updateMasterCheckbox() {
    this.isAllChecked = this.allFlags.every(flag => this[flag]);
  }

}